function parseCookies() {
	return document.cookie.split(';').reduce((cookies, cookie) => {
		const [name, value] = cookie.trim().split('=');
		if (name && value) {
			cookies[name] = decodeURIComponent(value);
		}
		return cookies;
	}, {});
}

function clearCookie(name) {
	document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
}

export function getAdParams() {
	const THIRTY_DAYS_IN_MS = 30 * 24 * 60 * 60 * 1000;
	let params = {};

	const cookies = parseCookies();
	const cookieTimestamp = cookies['ad_timestamp'];
	if (cookieTimestamp) {
		const age = Date.now() - parseInt(cookieTimestamp, 10);
		if (age <= THIRTY_DAYS_IN_MS) {
			params.fbclid = cookies['fbclid'];
			params.gclid = cookies['gclid'];
			params.msclkid = cookies['msclkid'];
			return params;
		} else {
			clearCookie('fbclid');
			clearCookie('gclid');
			clearCookie('msclkid');
			clearCookie('ad_timestamp');
		}
	}

	const adParams = ['fbclid', 'gclid', 'msclkid'];
	for (const adParam of adParams) {
		const data = localStorage.getItem(adParam);
		if (!data) return null;
		const parsedData = JSON.parse(data);
		const result = Date.now() - parsedData.timestamp <= THIRTY_DAYS_IN_MS ? parsedData.value : null;
		params[adParam] = result;
	}
	return params;
}